module.exports = __webpack_public_path__ + "image-86f5dc9daee4.png";